// extracted by css-extract-rspack-plugin
export default {"root":"root-LC7SeP"};